import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import './HomePage.scss'
import { _Api } from "../../common/api";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import SaleContent from "../include/Common/SaleContent";
import CollectionBlock from "../include/Common/CollectionBlock";
import CollectionSlider from "../include/Common/CollectionSlider";
import RightArrowIcon from "../assets/icons/RightArrowIcon";
import BottomBar from "../include/Common/BottomBar";
import JwelleNewArrival from "./JwelleNewArrival"
import { useNavigate } from "react-router-dom";
import BestSellerItems from "./BestSellerItems";
import Spinner from "Ecommerce/common/Spinner";
// import altimagebanner from "../assets/images/placeholder-banners.jpg";
const altimagebanner = "";

const HomePage = (props) => {
    const { t } = useTranslation();
    const [bannerList, setBannerList] = useState([]);
    const navigate = useNavigate();
    const [filterTag, setFilterTag] = useState('');
    // const [keyicon, setkeyicon] = useState(0);
    const [loader,  setLoader] = useState(false);
    // const [bestSellersData,setBestSellerData] =useState( [ ]);
    const [bestSellerCardDetails,setbscd] = useState([]);

    useEffect(() => {
        // getbestsellerfilterlist();
        getBanners();
    }, []);
    
    // const getbestsellerfilterlist = async () => {
    //     try {
    //         let postdata = {}
    //         let res = await _Api(postdata, `product/best-seller`);
    //         if (res.statusCode === 200) {
    //             // console.log(res.data, "Here is responsefff")
    //             setbscd([...res.data])
    //             setBestSellerData(res.items)
    //         }
    //     }
    //     catch (err) {
    //         console.log(err, "Error")
    //     }
    // }
    const getBanners = async () => {
        try {
            setLoader(true)
            let postdata = {}
            let res = await _Api(postdata, `Cms/get-ecom-bannerdata`);
            if (res.status === 200) {
                setLoader(false)
                setBannerList(res.data)
                // console.log(res, "Here is response")
            }
            setLoader(false)
        }
        catch (err) {
            setLoader(false)
            console.log(err, "Error")
        }
    }
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };
    var settings = {
        dots: true,
        infinite: true,
        speed: 2000,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        fade: true,
    };
    return (
        <>
            <div className={'ecommerce-main-layout-bodyContent position-relative templatethreehomepage'}>
                {/* product filter */}
                <div className="ecommerce-homepage">
                    {/* <SubHeader/> */}
                    <div className="ecommerce-homepage-top_banner">
                        <Slider {...settings}>
                            {bannerList?.length ? bannerList.map((bannerItem, key) => {
                                return (
                                    <div className="banner_holder" key={key}>
                                        <img src={bannerItem.Imageurl} alt="banner" />
                                    </div>
                                )
                            }) : loader ? <Spinner/> :
                                <div className="banner_holder">
                                    <img src={altimagebanner} alt="defaultbanner" />
                                </div>
                            }
                        </Slider>
                        <div onClick={scrollToTop} className="ecommerce-homepage-top_banner-icon ">
                            <RightArrowIcon />
                        </div>
                    </div>
                    <div className="ecommerce-homepage-salesection">
                        <SaleContent />
                    </div>
                    <div className="ecommerce-homepage-jwelle_container">
                        <div className="ecommerce-homepage-jwelle_container-inner">
                            <JwelleNewArrival />
                        </div>
                    </div>
                    <div className="ecommerce-homepage-collections">
                        <CollectionBlock />
                    </div>
                    <div className="ecommerce-homepage-bestsellers">
                        <div className="ecommerce-homepage-bestsellers-title">{t("Best Sellers")}</div>
                        {/* <div className="ecommerce-homepage-bestsellers-items">
                            {bestSellersData.length > 0 ? bestSellersData.map((item, key) => {
                                return (
                                    <div className={`ecommerce-homepage-bestsellers-items-button ${keyicon === key ? 'active' : ''}`} onClick={() => { setFilterTag(item); setkeyicon(key) }}>
                                        {t(`${item}`)}
                                    </div>
                                )
                            })
                                : null
                            }
                        </div> */}
                        {/* <div className="ecommerce-homepage-bestsellers-collection"> */}
                            <BestSellerItems  bestSellerCardDetails = {bestSellerCardDetails}/>
                        {/* </div> */}
                    </div>
                    <div className="ecommerce-homepage-exploreallbtn">
                        <button onClick={() => navigate("/best-seller")}>{t("Explore All")}</button>
                    </div>

                    <div className="ecommerce-homepage-home_collectionslider">
                        <div className="ecommerce-homepage-home_collectionslider-title">
                            {t("Love to see more collections")}
                        </div>
                        <CollectionSlider />
                    </div>
                    <BottomBar withTitle={true} />
                    {/* <div className="ecommerce-homepage-bottombar">
                        <div className="ecommerce-homepage-bottombar-title">
                            {t("Our Services")}
                            </div>
                        <div className="ecommerce-homepage-bottombar-inner">
                            
                            {bottomdata.length ? bottomdata.map((item, i)=>{
                                return(
                                    <div className={`ecommerce-homepage-bottombar-inner-container ${i === 0 ? "" : "hasborder"}`}>
                                        <span className="ecommerce-homepage-bottombar-inner-container-icon">{ item.icon ? item.icon : <SearchIcon/>}</span>
                                        <div className="ecommerce-homepage-bottombar-inner-container-content">
                                            <span className="ecommerce-homepage-bottombar-inner-container-content-title">{item.title}</span>
                                            <span className="ecommerce-homepage-bottombar-inner-container-content-subtitle">{item.subtitle}</span>
                                        </div>
                                    </div>
                                )
                            }) : null}
                            
                        </div>
                    </div> */}
                </div>

            </div >
        </>
    );
}
export default HomePage;